(() => {
  class TabsAccordion {
    constructor(root) {
      this.root = root;

      // Mark initialized so we don't double-bind
      if (this.root.dataset.tabsInit === '1') return;
      this.root.dataset.tabsInit = '1';

      // Ensure tab buttons don't accidentally submit forms if nesting changes
      this.root.querySelectorAll('.tab-button').forEach((btn) => {
        if (!btn.getAttribute('type')) btn.setAttribute('type', 'button');
      });

      this.movingButton = this.root.querySelector('.moving_button');

      this.bindDelegatedClicks();
      this.bindSwipeIfAvailable();
    }

    bindDelegatedClicks() {
      this.root.addEventListener('click', (e) => {
        const btn = e.target.closest('.tab-button');
        if (!btn || !this.root.contains(btn)) return;

        e.preventDefault();
        e.stopPropagation();

        const targetId = btn.getAttribute('data-target');
        if (!targetId) return;

        this.activate(targetId, btn.innerHTML);
      });
    }

    bindSwipeIfAvailable() {
      if (!this.movingButton) return;
      if (typeof window.Hammer === 'undefined') return;

      const hammer = new window.Hammer(this.movingButton);

      hammer.on('panleft panright', (ev) => {
        if (!ev.isFinal) return;

        const buttons = Array.from(this.root.querySelectorAll('.tab-button'));
        if (buttons.length < 2) return;

        const nextBtn = ev.type === 'panleft' ? buttons[0] : buttons[1];
        const targetId = nextBtn.getAttribute('data-target');
        if (!targetId) return;

        this.activate(targetId, nextBtn.innerHTML);
      });
    }

    activate(targetId, buttonHTML) {
      const buttons = Array.from(this.root.querySelectorAll('.tab-button'));
      const panels = Array.from(this.root.querySelectorAll('.tab-panel'));

      // Toggle button state
      buttons.forEach((b) => b.classList.toggle('active', b.getAttribute('data-target') === targetId));

      // Toggle panel state
      panels.forEach((p) => p.classList.toggle('active', p.id === targetId));

      // Update moving button label/pos (if used by your CSS)
      if (this.movingButton) {
        this.movingButton.dataset.pos = targetId;
        this.movingButton.innerHTML = `<span>${buttonHTML}</span>`;
      }
    }
  }

  const initAll = (scope = document) => {
    scope.querySelectorAll('.tabs').forEach((el) => new TabsAccordion(el));
  };

  // Init now
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  // If content gets injected later (popup open / section render), re-init
  const obs = new MutationObserver(() => initAll());
  obs.observe(document.documentElement, { childList: true, subtree: true });

  // Optional manual hook
  window.__initSizeGuideTabs = () => initAll();
})();